import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form } from 'semantic-ui-react'

import SeguroPermite from '../../../components/funcionales/seguropermite'

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'
var moment = require('moment');

//dropdown EMPRESAS
const DetalleEmpNivel1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrEmpresa}</option>
  )
};

const ListaEmp = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={(ev)=>handleChange(ev)}>
        {/* <option value="">Seleccionar Empresa...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown EMPRESAS

//Lista de mecanismos
const DetallePl = ({elemento, indice, handleChange}) => {
  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>
        <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkSeleccInf" checked={elemento.checkSeleccInf} onChange={(ev)=>handleChange(ev, indice)}/>
      </td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nombreUsuario}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMetodo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrTarea}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrFrecuencia}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaProx}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.acumulado?elemento.acumulado:0}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.acumProx?elemento.acumProx:0}</td>
    </tr>
  )
};
const ListaPl = ({list, handleChange}) => {
    const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} key={i} indice={i}
      handleChange={handleChange}/>);
    return(
      <tbody className=''>
        {nivel1Detalle}
      </tbody>
    )
  };

//FIN Lista de mecanismos

class ProgGenProg2 extends React.Component {
  state={list: 
    this.props.allPlantaRtes1.allPlantaRtes?this.props.allPlantaRtes1.allPlantaRtes.map((elemento, i) => ({
      ...elemento, checkSeleccInf: true
    })):[],
    argsDocum: {descrEmpresa: "Seleccionar Empresa...", desde: this.props.fechaHoy, hasta: this.props.fechaFin},
      permiteUpdate: true, confirmaAct: false, open: false, argsBuscProg: {}, checkSeleccInfAll: true, 
      argsQuery: `{"$unwind": "$secciones"},
        {"$unwind": "$secciones.equipos"},
        {"$unwind": "$secciones.equipos.componentes"},
        {"$unwind": "$secciones.equipos.componentes.mecanismos"},
        {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
        {$project: {idPlanta: '$_id', descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
          codSeccion: '$secciones.codSeccion',
          descrSeccion: '$secciones.descrSeccion',
          codEquipo: '$secciones.equipos.codEquipo',
          descrEquipo: '$secciones.equipos.descrEquipo',
          descrPrograma: '$secciones.equipos.descrPrograma',
          nombreUsuario: '$secciones.equipos.nombreUsuario',
          cedula: '$secciones.equipos.cedula',
          acumulado: '$secciones.equipos.acumulado',
          codComponente: '$secciones.equipos.componentes.codComponente',
          descrComponente: '$secciones.equipos.componentes.descrComponente',
          codMecanismo: '$secciones.equipos.componentes.mecanismos.codMecanismo',
          codigoQR: '$secciones.equipos.componentes.mecanismos.codigoQR',
          descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
          claseLub: '$secciones.equipos.componentes.mecanismos.claseLub',
          descrAplicacion: '$secciones.equipos.componentes.mecanismos.descrAplicacion',
          descrFabricante: '$secciones.equipos.componentes.mecanismos.descrFabricante',
          descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante',
          categoriaLub: '$secciones.equipos.componentes.mecanismos.categoriaLub',
          tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
          tipoFrecuencia: '$secciones.equipos.componentes.mecanismos.tipoFrecuencia',
          abrevUnidadTF: '$secciones.equipos.componentes.mecanismos.abrevUnidadTF',
          cantidadTotal: '$secciones.equipos.componentes.mecanismos.cantidadTotal',
          descrUnidad: '$secciones.equipos.componentes.mecanismos.descrUnidad',
          abrevUnidad: '$secciones.equipos.componentes.mecanismos.abrevUnidad',
          fechaUlt: '$secciones.equipos.componentes.mecanismos.programacion.fechaUlt',
          fechaProx: '$secciones.equipos.componentes.mecanismos.programacion.fechaProx',
          acumUlt: '$secciones.equipos.componentes.mecanismos.programacion.acumUlt',
          acumProx: '$secciones.equipos.componentes.mecanismos.programacion.acumProx',  
          consecutivo: '$secciones.equipos.componentes.mecanismos.programacion.consecutivo',        
          descrMetodo: '$secciones.equipos.componentes.mecanismos.programacion.descrMetodo',
          descrTarea: '$secciones.equipos.componentes.mecanismos.programacion.descrTarea',
          modoTarea: '$secciones.equipos.componentes.mecanismos.programacion.modoTarea',
          requiereSISO: '$secciones.equipos.componentes.mecanismos.programacion.requiereSISO',
          consecutivo: '$secciones.equipos.componentes.mecanismos.programacion.consecutivo',
          cantidad: '$secciones.equipos.componentes.mecanismos.programacion.cantidad',
          puntosLub: '$secciones.equipos.componentes.mecanismos.programacion.puntosLub',
          minutos: '$secciones.equipos.componentes.mecanismos.programacion.minutos',
          descrFrecuencia: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuencia',
          descrFrecuenciaPre: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuenciaPre',
          codProcedimiento: '$secciones.equipos.componentes.mecanismos.programacion.codProcedimiento',
          descrInfoTarea: '$secciones.equipos.componentes.mecanismos.programacion.descrInfoTarea',
          codInfoTarea: '$secciones.equipos.componentes.mecanismos.programacion.codInfoTarea',
          nombreArchivoInfo: '$secciones.equipos.componentes.mecanismos.programacion.nombreArchivoInfo',
          nombreArchivo: '$secciones.equipos.componentes.mecanismos.programacion.nombreArchivo',
          enRuta: '$secciones.equipos.componentes.mecanismos.programacion.enRuta',
          activo: '$secciones.equipos.componentes.mecanismos.programacion.activo',
          ultObservacion: '$secciones.equipos.componentes.mecanismos.programacion.ultObservacion',
          numCarta: {
            $let: {
                vars: {acumulado: {$toInt: '$secciones.equipos.acumulado'}, acumProx: {$toInt: '$secciones.equipos.componentes.mecanismos.programacion.acumProx'}},
                in: { $cond: { if: { $gte: [ "$$acumulado", "$$acumProx" ] }, then: "SI", else: "NO" } }
            }
          }
        }}`
    }

  nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await this.props.editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        const {data} = await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  handleChange = async (ev, indice) => {
    console.log("Refetch change 1")      

    if(ev.target.name === "checkSeleccInfAll"){
      const list = this.state.list
      let checkSeleccInfAll = this.state.checkSeleccInfAll
      if(checkSeleccInfAll){
        checkSeleccInfAll = false
      }else{
        checkSeleccInfAll = true
      }
      for(let i=0; i<list.length; i++){
        list[i].checkSeleccInf = checkSeleccInfAll
      }
      this.setState({checkSeleccInfAll});
      this.setState({list});
    }

    if(ev.target.name === "checkSeleccInf"){
      const list = this.state.list
      let checkSeleccInfAll = this.state.checkSeleccInfAll
      list[indice].checkSeleccInf = ev.target.checked
      checkSeleccInfAll = false
      this.setState({checkSeleccInfAll});
      this.setState({list});
    }    
    
    if(ev.target.name==="descrEmpresa"||ev.target.name==="desde"||ev.target.name==="hasta"){
      const argsDocum = this.state.argsDocum
      argsDocum[ev.target.name] = ev.target.value
      let argsBuscar=""
      if(ev.target.name==="descrEmpresa"){
        argsBuscar += `'descrEmpresa': '${ev.target.value}'`
      }else{
        argsBuscar += `'descrEmpresa': '${argsDocum.descrEmpresa}'`
      }
      if(this.props.argsBuscProg.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${this.props.argsBuscProg.descrPlanta}/i`
      }
      if(this.props.argsBuscProg.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${this.props.argsBuscProg.descrSeccion}/i`
      }
      if(this.props.argsBuscProg.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${this.props.argsBuscProg.descrEquipo}/i`
      }
      if(this.props.argsBuscProg.descrComponente){
        argsBuscar += `, 'descrComponente': /${this.props.argsBuscProg.descrComponente}/i`
      }
      if(this.props.argsBuscProg.descrMecanismo){
        argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscProg.descrMecanismo}/i`
      }
      if(this.props.argsBuscProg.descrFrecuencia){
        argsBuscar += `, 'descrFrecuencia': /${this.props.argsBuscProg.descrFrecuencia}/i`
      }
      if(this.props.argsBuscProg.descrTarea){
        argsBuscar += `, 'descrTarea': /${this.props.argsBuscProg.descrTarea}/i`
      }
      if(this.props.argsBuscProg.descrPrograma){
        argsBuscar += `, 'descrPrograma': /${this.props.argsBuscProg.descrPrograma}/i`
      }

      let argsBuscarF = ""
      if(ev.target.name==="descrEmpresa"){
        argsBuscarF = `${argsBuscar}, fechaProx: { $lte: '${argsDocum.hasta}' }`
      }else{
        if(ev.target.name==="desde"){
          argsBuscarF = `${argsBuscar}, fechaProx: { $lte: '${argsDocum.hasta}' }`
        }else{
          argsBuscarF = `${argsBuscar}, fechaProx: { $lte: '${ev.target.value}' }`
        }
      }
      argsBuscar += `,
        $or: [
          { tipoFrecuencia: "Calendario", descrFrecuencia: {$ne: "Diario"}, ${argsBuscarF}},
          { tipoFrecuencia: "Calendario", descrFrecuencia: "Diario"},
          { tipoFrecuencia: {$ne: "Calendario"}, numCarta: "SI" }
        ]
      `
    let argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {'activo': 'S', 'enRuta': 'N', ${argsBuscar}}}]`}
    console.log(argsBuscarPl)
      await this.props.allPlantaRtes1.refetch(argsBuscarPl)
// console.log("Refetch change 2")      
      if(this.props.allPlantaRtes1.allPlantaRtes){
        this.setState({list: 
          this.props.allPlantaRtes1.allPlantaRtes?this.props.allPlantaRtes1.allPlantaRtes.map((elemento, i) => ({
            ...elemento, checkSeleccInf: true
          })):[]
        })
        this.setState({checkSeleccInfAll: true});
      }
      this.setState({argsDocum});
    }
  }

  handleSubmit = async (ev, list1, argsDocum)=>{
    let list = await list1.filter(elemento => elemento.checkSeleccInf === true)

    if(list.length>0){
      let generandoProg = this.props.getParametro.getParametro.generandoProg
      if(generandoProg==="N"){
        document.body.style.cursor = 'wait'

        let argsUpdPar = {}
        argsUpdPar = {
          _id: this.props.getParametro.getParametro._id,
          mensaje: this.props.getParametro.getParametro.mensaje,
          empresaRazonSocial: this.props.getParametro.getParametro.empresaRazonSocial?this.props.getParametro.getParametro.empresaRazonSocial:"",
          empresaNit: this.props.getParametro.getParametro.empresaNit?this.props.getParametro.getParametro.empresaNit:"",
          empresaWeb: this.props.getParametro.getParametro.empresaWeb?this.props.getParametro.getParametro.empresaWeb:"",
          empresaDir1: this.props.getParametro.getParametro.empresaDir1?this.props.getParametro.getParametro.empresaDir1:"",
          empresaTel1: this.props.getParametro.getParametro.empresaTel1?this.props.getParametro.getParametro.empresaTel1:"",
          empresaCel1: this.props.getParametro.getParametro.empresaCel1?this.props.getParametro.getParametro.empresaCel1:"",
          empresaCiudad1: this.props.getParametro.getParametro.empresaCiudad1?this.props.getParametro.getParametro.empresaCiudad1:"",
          empresaDir2: this.props.getParametro.getParametro.empresaDir2?this.props.getParametro.getParametro.empresaDir2:"",
          empresaTel2: this.props.getParametro.getParametro.empresaTel2?this.props.getParametro.getParametro.empresaTel2:"",
          empresaCel2: this.props.getParametro.getParametro.empresaCel2?this.props.getParametro.getParametro.empresaCel2:"",
          empresaCiudad2: this.props.getParametro.getParametro.empresaCiudad2?this.props.getParametro.getParametro.empresaCiudad2:"",
          empresaBanco1: this.props.getParametro.getParametro.empresaBanco1?this.props.getParametro.getParametro.empresaBanco1:"",
          empresaCuenta1: this.props.getParametro.getParametro.empresaCuenta1?this.props.getParametro.getParametro.empresaCuenta1:"",
          empresaBanco2: this.props.getParametro.getParametro.empresaBanco2?this.props.getParametro.getParametro.empresaBanco2:"",
          empresaCuenta2: this.props.getParametro.getParametro.empresaCuenta2?this.props.getParametro.getParametro.empresaCuenta2:"",
          empresaPresentacion: this.props.getParametro.getParametro.empresaPresentacion?this.props.getParametro.getParametro.empresaPresentacion:"",
          empresaNombreFirma: this.props.getParametro.getParametro.empresaNombreFirma?this.props.getParametro.getParametro.empresaNombreFirma:"",
          empresaCargoFirma: this.props.getParametro.getParametro.empresaCargoFirma?this.props.getParametro.getParametro.empresaCargoFirma:"",
          empresaMailFirma: this.props.getParametro.getParametro.empresaMailFirma?this.props.getParametro.getParametro.empresaMailFirma:"",
          empresaCelFirma: this.props.getParametro.getParametro.empresaCelFirma?this.props.getParametro.getParametro.empresaCelFirma:"",
          rutaLogo: this.props.getParametro.getParametro.rutaLogo?this.props.getParametro.getParametro.rutaLogo:"",
          generandoProg: "S"
        }
        if(2>1){
          const response = await this.props.editParametro({
            variables: argsUpdPar
          });
          const {errors, success} = response.data.editParametro;
        }

        // let numeroOrden = await this.nextVal('numeroOrden')
        // numeroOrden-=1
        let numeroRuta = await this.nextVal('ruta')

        //Archivo Excel
        let xlsString = []
        let xlsString1 = []
        xlsString1 = ['Ruta', 'OT', 'OT SAP', 'Frecuencia', 'Fecha última ejec.', 'Año', 'Mes', 'Día', 'Planta', 'Sección', 'Equipo', 'Componente',
          'Mecanismo', 'Método', 'Tarea', 'Modo tarea', 'Requiere SISO', 'Lubricante', 'Cantidad', 'Und', 'Puntos', 'Minutos', 'Alim. sistema', 'Realizado?', 'Año real', 'Mes real', 'Día real', 'Hora real (0-23)',
          'Operario real', 'Cant. real', 'Min. real', 'Acum. Horas/Km', 'Temperatura antes lub.', 'Temperatura despues lub.', 
          'Ultrasonido antes lub.', 'Ultrasonido despues lub.', 'Vibraciones antes lub.', 'Vibraciones despues lub.', 'Observación anterior', 'Observación actual', 'Rep. Lab.', 'Inf. Lab.', 'Hallazgo - Falla por lubricación (S/N)', 'Hallazgo - Duración falla (Horas)', 'Hallazgo - Costo por falla ($)']
        xlsString.push(xlsString1)

        let allFrecuencia = this.props.allFrecuencia.allFrecuencia
        let addColeccPl = [], creaColecc = []

        for (let iiii=0;iiii<list.length;iiii++){
          let numProgs=0
          let indexFre=0
          let cantidadFreAcum = 0

          if(list[iiii].tipoFrecuencia==='Calendario'){
            // console.log(list[iiii].descrFrecuencia, list[iiii].descrFrecuenciaPre)
            if(list[iiii].descrFrecuencia==='Predictiva'){
              indexFre = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===list[iiii].descrFrecuenciaPre )
            }else{
              indexFre = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===list[iiii].descrFrecuencia )
            }
            if(indexFre===-1 || !allFrecuencia[indexFre].cantidad){
              console.log(list[iiii].descrFrecuencia)
            }else{
              let cantidadFre = allFrecuencia[indexFre].cantidad 
              let fechaHasta = argsDocum.hasta
              let fechaNum = 0
              let fechaHastaNum = parseInt((new Date(fechaHasta).getTime()), 10)
              do { 
                let fechaDesde = moment(argsDocum.desde).format('YYYY-MM-DD')
                let fechaFin = moment()
                

                numProgs+=1;
                cantidadFreAcum = cantidadFreAcum + cantidadFre
    
                if((parseInt((new Date(list[iiii].fechaProx).getTime()), 10) < parseInt((new Date(fechaDesde).getTime()), 10)) || list[iiii].descrFrecuencia==='Diario'){
                  fechaFin = moment(argsDocum.desde).add(cantidadFreAcum, 'd').format('YYYY-MM-DD')
                }else{
                  fechaFin = moment(list[iiii].fechaProx).add(cantidadFreAcum, 'd').format('YYYY-MM-DD')
                }
                fechaNum = parseInt((new Date(fechaFin).getTime()), 10)
              } while (fechaHastaNum >= fechaNum);
            }
          }else{
            numProgs=1
          }
          cantidadFreAcum = 0
        
          for(let ii=0;ii<numProgs;ii++){
            let argsPl = {}, argsProg = {}
            let addColeccProg = []
            let descrMetodo = list[iiii].descrMetodo
            let descrTarea = list[iiii].descrTarea
          
            // numeroOrden+=1
            let numeroOrden = await this.nextVal('numeroOrden')
  
            let argsAdd = {
              "ruta": numeroRuta,
              "numeroOrden": numeroOrden,
              "ordenSAP": "",
              "estadoOrden": "Abierto",
              "fechaIni": argsDocum.desde,
              "fechaFin": argsDocum.hasta,
              "nombreUsuario": list[iiii].nombreUsuario?list[iiii].nombreUsuario:"",
              "cedula": list[iiii].cedula?list[iiii].cedula:"",
              "mail": "",
              "telefono": "",
              "descrEmpresa": list[iiii].descrEmpresa,
              "descrPlanta": list[iiii].descrPlanta,
              "codPlanta": list[iiii].codPlanta?list[iiii].codPlanta:"",
              "descrSeccion": list[iiii].descrSeccion,
              "codSeccion": list[iiii].codSeccion?list[iiii].codSeccion:"",
              "descrEquipo": list[iiii].descrEquipo,
              "codEquipo": list[iiii].codEquipo?list[iiii].codEquipo:"",
              "descrPrograma": list[iiii].descrPrograma?list[iiii].descrPrograma:"Sin programa",
              "descrComponente": list[iiii].descrComponente,
              "codComponente": list[iiii].codComponente?list[iiii].codComponente:"",
              "descrMecanismo": list[iiii].descrMecanismo,
              "codMecanismo": list[iiii].codMecanismo?list[iiii].codMecanismo:"",
              "codigoQR": list[iiii].codigoQR?list[iiii].codigoQR:"",
              "claseLub": list[iiii].claseLub,
              "tipoLub": list[iiii].tipoLub,
              "descrFabricante": list[iiii].descrFabricante,
              "descrLubricante": list[iiii].descrLubricante,
              "descrAplicacion": list[iiii].descrAplicacion,
              "tipoFrecuencia": list[iiii].tipoFrecuencia,
              "abrevUnidadTF": list[iiii].abrevUnidadTF,
              "cantidadTotal": list[iiii].cantidadTotal?list[iiii].cantidadTotal:0,
              "descrUnidad": list[iiii].descrUnidad,
              "abrevUnidad": list[iiii].abrevUnidad,
              "cantidad": list[iiii].cantidad,
              "puntosLub": list[iiii].puntosLub,
              "minutos": list[iiii].minutos,
              "descrMetodo": list[iiii].descrMetodo,
              "descrTarea": list[iiii].descrTarea?list[iiii].descrTarea:"",
              "modoTarea": list[iiii].modoTarea,
              "requiereSISO": list[iiii].requiereSISO,
              "descrFrecuencia": list[iiii].descrFrecuencia,
              "descrFrecuenciaPre": list[iiii].descrFrecuenciaPre?list[iiii].descrFrecuenciaPre:"",
              "acumulado": list[iiii].acumulado?list[iiii].acumulado:0,
              "fechaUlt": list[iiii].fechaUlt?list[iiii].fechaUlt:"",
              "fechaProx": list[iiii].fechaProx?list[iiii].fechaProx:"",
              "acumUlt": list[iiii].acumUlt?list[iiii].acumUlt:0,
              "acumProx": list[iiii].acumProx?parseInt(list[iiii].acumProx):0,
              "observaciones": list[iiii].ultObservacion?list[iiii].ultObservacion:"",
              "realizado": "N", 
              "alimSistema": "N",
              "acumReal": list[iiii].acumulado?list[iiii].acumulado:0,
              "cantidadReal": list[iiii].cantidad,
              "minutosReal": list[iiii].minutos,  
              "observacionesReal": list[iiii].ultObservacion?list[iiii].ultObservacion:"",
              "nombreUsuarioReal": list[iiii].nombreUsuario,
              "cedulaReal": list[iiii].cedula,
              "codProcedimiento": list[iiii].codProcedimiento?list[iiii].codProcedimiento:"",
              "nombreArchivo": list[iiii].nombreArchivo?list[iiii].nombreArchivo:"",
              "codInfoTarea": list[iiii].codInfoTarea?list[iiii].codInfoTarea:"",
              "descrInfoTarea": list[iiii].descrInfoTarea?list[iiii].descrInfoTarea:"",
              "nombreArchivoInfo": list[iiii].nombreArchivoInfo?list[iiii].nombreArchivoInfo:"",
              "numeroInflab": 0,
              "mecInflab": 0,
              "imgAntes": "",
              "imgDespues": "",
              "videoAntes": "",
              "videoDespues": "",
            }

            let campoAgno = ''
            let campoMes = ''
            let campoDia= ''
            let fechaFin = moment()
            let fechaDesde = moment(argsDocum.desde).format('YYYY-MM-DD')

            if(list[iiii].tipoFrecuencia==='Calendario'){
              
              if(list[iiii].descrFrecuencia==='Predictiva'){
                indexFre = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===list[iiii].descrFrecuenciaPre )
              }else{
                indexFre = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===list[iiii].descrFrecuencia )
              }
            
              if((parseInt((new Date(list[iiii].fechaProx).getTime()), 10) < parseInt((new Date(fechaDesde).getTime()), 10)) || list[iiii].descrFrecuencia==='Diario'){
                if(ii===0){
                  argsAdd['fechaProg'] = fechaDesde
                  argsAdd['fechaReal'] = fechaDesde
                  argsAdd['horaReal'] = 8
                  campoAgno = fechaDesde.substring(0, 4)
                  campoMes = fechaDesde.substring(5, 7)
                  campoDia = fechaDesde.substring(8, 10)
                }else{
                  fechaFin = moment(fechaDesde).add(cantidadFreAcum, 'd').format('YYYY-MM-DD')                
                  
                  campoAgno = fechaFin.substring(0, 4)
                  campoMes = fechaFin.substring(5, 7)
                  campoDia = fechaFin.substring(8, 10)
                  argsAdd['fechaProg'] = fechaFin
                  argsAdd['fechaReal'] = fechaFin
                  argsAdd['horaReal'] = 8
                }
              }else{
                if(ii===0){
                  if(!list[iiii].fechaProx || list[iiii].fechaProx==="" || list[iiii].fechaProx===null){
                    argsAdd['fechaProg'] = fechaDesde
                    argsAdd['fechaReal'] = fechaDesde
                    argsAdd['horaReal'] = 8
                    campoAgno = fechaDesde.substring(0, 4)
                    campoMes = fechaDesde.substring(5, 7)
                    campoDia = fechaDesde.substring(8, 10)
                  }else{
                    argsAdd['fechaProg'] = list[iiii].fechaProx
                    argsAdd['fechaReal'] = list[iiii].fechaProx
                    argsAdd['horaReal'] = 8
                    campoAgno = list[iiii].fechaProx.substring(0, 4)
                    campoMes = list[iiii].fechaProx.substring(5, 7)
                    campoDia = list[iiii].fechaProx.substring(8, 10)
                  }
                }else{
                  fechaFin = moment(list[iiii].fechaProx).add(cantidadFreAcum, 'd').format('YYYY-MM-DD')
                  
                  campoAgno = fechaFin.substring(0, 4)
                  campoMes = fechaFin.substring(5, 7)
                  campoDia = fechaFin.substring(8, 10)  
                  argsAdd['fechaProg'] = fechaFin
                  argsAdd['fechaReal'] = fechaFin     
                  argsAdd['horaReal'] = 8       
                }             
              }      

              let cantidadFre = allFrecuencia[indexFre].cantidad   
              cantidadFreAcum=cantidadFreAcum + cantidadFre
            }else{
              campoAgno = fechaDesde.substring(0, 4)
              campoMes = fechaDesde.substring(5, 7)
              campoDia = fechaDesde.substring(8, 10)
              argsAdd['fechaProg'] = fechaDesde
              argsAdd['fechaReal'] = fechaDesde    
              argsAdd['horaReal'] = 0    
            }
            argsAdd['tipoAct'] = "Web"
            let response = await this.props.fecha({
              variables: {}
            }); 
            const {fechaHoraHoy} = response.data.fecha
            argsAdd['fechaCreate'] = fechaHoraHoy;
            argsAdd['usuarioCreate'] = localStorage.getItem('userLogin')
            creaColecc.push(argsAdd)  
            argsAdd = {}

            argsProg['descrMetodo'] = descrMetodo
            argsProg['descrTarea'] = descrTarea
            argsProg['enRuta'] = 'S'

            addColeccProg.push(argsProg)
            argsProg = {}

            argsPl['descrEmpresa'] = list[iiii].descrEmpresa
            argsPl['descrPlanta'] = list[iiii].descrPlanta
            argsPl['descrSeccion'] = list[iiii].descrSeccion
            argsPl['descrEquipo'] = list[iiii].descrEquipo
            argsPl['descrComponente'] = list[iiii].descrComponente
            argsPl['descrMecanismo'] = list[iiii].descrMecanismo

            argsPl['programacion'] = addColeccProg
            argsPl['tipoAct'] = "EditarProgramacionRuta"
            
            addColeccPl.push(argsPl)

            argsPl = {}
            addColeccProg = []

            let fechaUlt=''
            if(list[iiii].fechaUlt!==null && list[iiii].fechaUlt!==''){
              fechaUlt = list[iiii].fechaUlt.substr(0, 10)
            }

            xlsString1 = [numeroRuta, numeroOrden, '', list[iiii].descrFrecuencia, fechaUlt, campoAgno, campoMes, campoDia, list[iiii].descrPlanta,
            list[iiii].descrSeccion, list[iiii].descrEquipo, list[iiii].descrComponente, list[iiii].descrMecanismo, 
            list[iiii].descrMetodo, list[iiii].descrTarea, list[iiii].modoTarea, list[iiii].requiereSISO, list[iiii].descrLubricante, list[iiii].cantidad, 
            list[iiii].abrevUnidad, list[iiii].puntos, list[iiii].minutos, 'N', 'N', campoAgno, campoMes, campoDia, 8, 
            list[iiii].cedula, list[iiii].cantidad, list[iiii].minutos, list[iiii].acumulado, '', '', '', '', '', '', list[iiii].ultObservacion, list[iiii].ultObservacion, 0, 0, 'N', 0, 0]

            xlsString.push(xlsString1)
          } 

          if(iiii===list.length-1){
            let updColeccProg = [], updColeccProg1 = [], addColeccOrden = [], addColeccOrden1 = []
            for(let iii=0; iii<creaColecc.length; iii++){
              addColeccOrden.push(creaColecc[iii])
            }
            
            addColeccOrden1.push({orden: addColeccOrden})

            let numDocCRUD = 0
            let totDocCRUD = 1
            let argsCrud = []
            let crudColecc = []

            for(let iii=0; iii<totDocCRUD; iii++){
              argsCrud.push({ctrlCampo: 'NO_CRUD'})
            }
            for(let iii=0; iii<totDocCRUD; iii++){
              crudColecc.push(this.props.createOrdenMany)
            }
            argsCrud[numDocCRUD] = addColeccOrden1[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.createOrdenMany

            await this.updColecc(crudColecc, argsCrud, totDocCRUD)
            
            // const argsUpd = {
            //   coleccion: 'numeroOrden',
            //   seq: numeroOrden,
            // }

            // const response = await this.props.editSequence({
            //   variables: argsUpd
            // });
            // const {errors, success} = response.data.editSequence;

            

            for(let iii=0; iii<addColeccPl.length; iii++){
              updColeccProg.push(addColeccPl[iii])
            }
            
            updColeccProg1.push({planta: updColeccProg})
            
            // let updPar = []
            argsUpdPar = {
              _id: this.props.getParametro.getParametro._id,
              mensaje: this.props.getParametro.getParametro.mensaje,
              empresaRazonSocial: this.props.getParametro.getParametro.empresaRazonSocial?this.props.getParametro.getParametro.empresaRazonSocial:"",
              empresaNit: this.props.getParametro.getParametro.empresaNit?this.props.getParametro.getParametro.empresaNit:"",
              empresaWeb: this.props.getParametro.getParametro.empresaWeb?this.props.getParametro.getParametro.empresaWeb:"",
              empresaDir1: this.props.getParametro.getParametro.empresaDir1?this.props.getParametro.getParametro.empresaDir1:"",
              empresaTel1: this.props.getParametro.getParametro.empresaTel1?this.props.getParametro.getParametro.empresaTel1:"",
              empresaCel1: this.props.getParametro.getParametro.empresaCel1?this.props.getParametro.getParametro.empresaCel1:"",
              empresaCiudad1: this.props.getParametro.getParametro.empresaCiudad1?this.props.getParametro.getParametro.empresaCiudad1:"",
              empresaDir2: this.props.getParametro.getParametro.empresaDir2?this.props.getParametro.getParametro.empresaDir2:"",
              empresaTel2: this.props.getParametro.getParametro.empresaTel2?this.props.getParametro.getParametro.empresaTel2:"",
              empresaCel2: this.props.getParametro.getParametro.empresaCel2?this.props.getParametro.getParametro.empresaCel2:"",
              empresaCiudad2: this.props.getParametro.getParametro.empresaCiudad2?this.props.getParametro.getParametro.empresaCiudad2:"",
              empresaBanco1: this.props.getParametro.getParametro.empresaBanco1?this.props.getParametro.getParametro.empresaBanco1:"",
              empresaCuenta1: this.props.getParametro.getParametro.empresaCuenta1?this.props.getParametro.getParametro.empresaCuenta1:"",
              empresaBanco2: this.props.getParametro.getParametro.empresaBanco2?this.props.getParametro.getParametro.empresaBanco2:"",
              empresaCuenta2: this.props.getParametro.getParametro.empresaCuenta2?this.props.getParametro.getParametro.empresaCuenta2:"",
              empresaPresentacion: this.props.getParametro.getParametro.empresaPresentacion?this.props.getParametro.getParametro.empresaPresentacion:"",
              empresaNombreFirma: this.props.getParametro.getParametro.empresaNombreFirma?this.props.getParametro.getParametro.empresaNombreFirma:"",
              empresaCargoFirma: this.props.getParametro.getParametro.empresaCargoFirma?this.props.getParametro.getParametro.empresaCargoFirma:"",
              empresaMailFirma: this.props.getParametro.getParametro.empresaMailFirma?this.props.getParametro.getParametro.empresaMailFirma:"",
              empresaCelFirma: this.props.getParametro.getParametro.empresaCelFirma?this.props.getParametro.getParametro.empresaCelFirma:"",
              rutaLogo: this.props.getParametro.getParametro.rutaLogo?this.props.getParametro.getParametro.rutaLogo:"",
              generandoProg: "N"
            }
            if(2>1){
              const response = await this.props.editParametro({
                variables: argsUpdPar
              });
              const {errors, success} = response.data.editParametro;
            }
    
            numDocCRUD = 0
            totDocCRUD = 1
            argsCrud = []
            crudColecc = []

            for(let iii=0; iii<totDocCRUD; iii++){
              argsCrud.push({ctrlCampo: 'NO_CRUD'})
            }
            for(let iii=0; iii<totDocCRUD; iii++){
              crudColecc.push(this.props.editPlantaEstructura)
            }

            argsCrud[numDocCRUD] = updColeccProg1[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.editPlantaEstructura

            await this.updColecc(crudColecc, argsCrud, totDocCRUD)
            
            var wb = XLSX.utils.book_new();

            wb.Props = {
              Title: "SheetJS Tutorial",
              Subject: "Test",
              Author: "Red Stapler",
              CreatedDate: new Date(2017,12,19)
            };

            wb.SheetNames.push("Ordenes");

            let ws_data = xlsString;

            let ws = XLSX.utils.aoa_to_sheet(ws_data);
            wb.Sheets["Ordenes"] = ws;
            let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
            function s2ab(s) { 
              let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
              let view = new Uint8Array(buf);  //create uint8array as viewer
              for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
              return buf;    
            }
            saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'Ruta_'+numeroRuta+'_'+list[iiii].descrEmpresa+'.xlsx');
  //FIN Exportar a XLS
          }
        }

        document.body.style.cursor = 'default'

        this.setState({open: false, confirmaAct: false})
      }else{
        alert("!! Actualmente existe un proceso de generación de programación en curso.  por favor intente mas tarde !!")
      }
    }else{
      alert("!! No existen registros para programar !!")
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){
      this.setState({open: true})
    }else{
      this.setState({open: false})
    };
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  async componentDidUpdate(prevProps){
    if(this.props.argsBuscProg!==this.state.argsBuscProg){
      let argsBuscar=""
      argsBuscar += `'descrEmpresa': '${this.state.argsDocum.descrEmpresa}'`
      if(this.props.argsBuscProg.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${this.props.argsBuscProg.descrPlanta}/i`
      }
      if(this.props.argsBuscProg.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${this.props.argsBuscProg.descrSeccion}/i`
      }
      if(this.props.argsBuscProg.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${this.props.argsBuscProg.descrEquipo}/i`
      }
      if(this.props.argsBuscProg.descrComponente){
        argsBuscar += `, 'descrComponente': /${this.props.argsBuscProg.descrComponente}/i`
      }
      if(this.props.argsBuscProg.descrMecanismo){
        argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscProg.descrMecanismo}/i`
      }
      if(this.props.argsBuscProg.descrFrecuencia){
        argsBuscar += `, 'descrFrecuencia': /${this.props.argsBuscProg.descrFrecuencia}/i`
      }
      if(this.props.argsBuscProg.descrTarea){
        argsBuscar += `, 'descrTarea': /${this.props.argsBuscProg.descrTarea}/i`
      }
      if(this.props.argsBuscProg.descrPrograma){
        argsBuscar += `, 'descrPrograma': /${this.props.argsBuscProg.descrPrograma}/i`
      }
      argsBuscar += `,
        $or: [
          { tipoFrecuencia: "Calendario", descrFrecuencia: {$ne: "Diario"}, fechaProx: { $lte: '${this.state.argsDocum.hasta}' } },
          { tipoFrecuencia: "Calendario", descrFrecuencia: "Diario"},
          { tipoFrecuencia: {$ne: "Calendario"}, numCarta: "SI" }
        ]
      `
      let argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {'activo': 'S', 'enRuta': 'N', ${argsBuscar}}}]`}
      await this.props.allPlantaRtes1.refetch(argsBuscarPl)

//Cuando se usa await para que no ejecute de la siguiente linea en adelante se debe usar el resultado del await
//por eso el if de la siguiente linea
      if(this.props.allPlantaRtes1.allPlantaRtes){
        this.setState({argsBuscProg: this.props.argsBuscProg})
        if(this.props.allPlantaRtes1.allPlantaRtes&&prevProps.allPlantaRtes1.allPlantaRtes){
          if((this.props.allPlantaRtes1.allPlantaRtes!==prevProps.allPlantaRtes1.allPlantaRtes)||!this.state.list){
            this.setState({list: 
              this.props.allPlantaRtes1.allPlantaRtes?this.props.allPlantaRtes1.allPlantaRtes.map((elemento, i) => ({
                ...elemento, checkSeleccInf: true
              })):[]
            })
            this.setState({checkSeleccInfAll: true});
          }
        }
      }
    }
  }

  render(){
console.log("render 1")

    const {list, argsDocum, checkSeleccInfAll, permiteUpdate, confirmaAct, open} = this.state;
    // const a250110 = autorizacUA.findIndex( autorizac => autorizac === "250110" );
    let mensaje = "Generar programación"
    let imgIcon = "images/documento_32.png"
    
    let list1 = [], list2 = []
    if(this.props.descrEmpresaUA==="Todas..."){
      list2.push({descrEmpresa: "Seleccionar Empresa...", _id: 0})
      if(this.props.allEmpresa.allEmpresa){
        this.props.allEmpresa.allEmpresa.forEach((elemento, ii) => {
          list2.push({descrEmpresa: elemento.descrEmpresa, _id: ii+1})
        })
      }
    }else{
      list2.push({descrEmpresa: this.props.descrEmpresaUA, _id: 0})
    }
console.log("render 2")
    return (
      // <div>
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, list, argsDocum):()=>{}}>
            <div className="ui two column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '30%', paddingLeft: '1.2em'}}>
                  <Form.Field>
                    <ListaEmp styles={this.props.styles} list={list2} handleChange={this.handleChange} />
                  </Form.Field>
                </div>

                <div className="column" style={{width: '20%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Desde
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="desde" id="desde" value={argsDocum.desde} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '20%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Hasta
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="hasta" id="hasta" value={argsDocum.hasta} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '30%', paddingTop: '0.1em'}}>
                  <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
              </div>
            </div>
            <div>
              <div style={{height: '36em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>
                        <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkSeleccInfAll" checked={checkSeleccInfAll} onChange={this.handleChange}/>
                      </th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Operario</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Planta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Sección</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '16%'}}>Equipo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '18%'}}>Componente</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '18%'}}>Mecanismo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Metodo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Tarea</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Frecuencia</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Fecha prox.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Acumulado</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Acum. prox.</th>
                     </tr>
                  </thead>
                  <ListaPl list={list} handleChange={this.handleChange}/>
                </table>
                <p></p>
              </div>
            </div>
          </Form>
        </div>
      // </div>
    )
  }
};

export default compose(
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),

  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.query.allFrecuencia, {name:'allFrecuencia'}),
  graphql(queries.mutation.createOrdenMany, {name:'createOrdenMany'}),
  graphql(queries.mutation.createOrden, {name:'createOrden'}),
  graphql(queries.mutation.editPlantaEstructura, {name:'editPlantaEstructura'}),

  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),
  graphql(queries.mutation.editSequence, {name:'editSequence'}),
  graphql(queries.query.getParametro, {name:'getParametro', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.editParametro, {name:'editParametro'}),
  graphql(queries.mutation.fecha, {name:'fecha'}),
)(ProgGenProg2)
